import { EnumResponse } from '@/api/services/common.dto'
import { ConfigurationPersonnelNumberAssignmentResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-number-assignment/configuration-personnel-number-assignment.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentFormState {
    numbers: EnumResponse[]
    personnelNumberAssignments: ConfigurationPersonnelNumberAssignmentResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentFormState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentFormState => ({
        numbers: Array.from(Array(10).keys()).map(number => ({
            code: String(number),
            translatedName: String(number)
        })),
        personnelNumberAssignments: [],
        laboratoryId: store.getters.labId
    })
